import {
    GOOGLE_CAL_INTEGRATION_STATUS_AUTHED,
    GOOGLE_CAL_INTEGRATION_STATUS_SYNCING,
    GOOGLE_CAL_INTEGRATION_QUEUED_FOR_SYNCING,
    GOOGLE_CAL_INTEGRATION_STATUS_SYNC_FAILED
} from "../../utils/Constants";

export const VIEW_CONNECT = "connect";
export const VIEW_CONTINUE_SETUP = "continueSetup";
export const VIEW_DISCONNECT = "disconnect";

const OTHER_USER_CONNECT_TOOLTIP =
    "You cannot connect another user's Google Calendar";
const OTHER_USER_DISCONNECT_TOOLTIP =
    "You cannot disconnect another user's Google Calendar";

/**
 * Pure mapping from integration state to what the profile tab should render.
 *
 * Statuses (RefData integration|<providerId> / googleCal):
 *   (none)           -> Connect
 *   syncingFailed    -> Connect, disabled (support must intervene)
 *   authed           -> OAuth finished but no sync direction chosen yet:
 *                       let the user pick a direction, or disconnect.
 *   queuedForSyncing -> Disconnect, disabled while the import runs
 *   syncing          -> Disconnect, disabled while the import runs
 *   synced           -> Disconnect
 */
export function getGoogleCalIntegrationView({
    googleCalInfo,
    showIntegrationStatusOnly,
    isManagerView,
    isMutatingIntegration
}) {
    const status = googleCalInfo?.status;
    const viewingOtherUser = Boolean(showIntegrationStatusOnly || isManagerView);

    if (!googleCalInfo || status === GOOGLE_CAL_INTEGRATION_STATUS_SYNC_FAILED) {
        const failed = status === GOOGLE_CAL_INTEGRATION_STATUS_SYNC_FAILED;
        return {
            view: VIEW_CONNECT,
            disabled: Boolean(isMutatingIntegration || viewingOtherUser || failed),
            canDisconnect: false,
            tooltip: !failed && viewingOtherUser ? OTHER_USER_CONNECT_TOOLTIP : ""
        };
    }

    if (status === GOOGLE_CAL_INTEGRATION_STATUS_AUTHED) {
        const blocked = Boolean(isMutatingIntegration || viewingOtherUser);
        return {
            view: VIEW_CONTINUE_SETUP,
            disabled: blocked,
            canDisconnect: !blocked,
            tooltip: viewingOtherUser ? OTHER_USER_CONNECT_TOOLTIP : ""
        };
    }

    const inProgress =
        status === GOOGLE_CAL_INTEGRATION_STATUS_SYNCING ||
        status === GOOGLE_CAL_INTEGRATION_QUEUED_FOR_SYNCING;
    return {
        view: VIEW_DISCONNECT,
        disabled: Boolean(viewingOtherUser || inProgress),
        canDisconnect: !viewingOtherUser && !inProgress,
        tooltip: viewingOtherUser ? OTHER_USER_DISCONNECT_TOOLTIP : ""
    };
}
